import { FormattedMessage } from 'react-intl';

import { makeUrl, type SupportedKey } from './helpers';
import { regionSelectorWithDefault } from '../region/regionSlice';
import { useAppSelector } from '../../configuration/setup/hooks';
import { useCompanyLanguage } from '../companyInfo/companyInfoSlice.ts';
import { getLocale } from '../../configuration/lang/langSlice.ts';

const intlPath = (key: string) => `intl-msg:registration.personalData.gtcApprove.link.${key}`;

interface AemLinkProps {
    aemKey: SupportedKey;
    className?: string;
}

export const AemLink = (props: AemLinkProps) => {
    const lang = useCompanyLanguage();
    const fallbackLang = useAppSelector(getLocale);
    const region = useAppSelector(regionSelectorWithDefault);
    const { aemKey, className } = props;
    const intlId = intlPath(aemKey);
    const url = makeUrl(aemKey, lang ? lang : fallbackLang, region);

    return (
        <a className={className} href={url} target={'_blank'} rel={'noreferrer'}>
            <FormattedMessage id={intlId} />
        </a>
    );
};
